import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  LinearProgress,
  SelectChangeEvent,
  CircularProgress,
} from '@mui/material';
import './TankSelect.css';
import { StorageUnit } from './embryoCulture.helpers';
import { capitalizeTitle, RequiredLabel } from '../../../utils/commonUtils';

interface CanisterSelectProps {
  canisters: StorageUnit[];
  selectedCanister: number | null;
  onChange: (value: string) => void;
  label?: string;
  loading: boolean;
  hasError?: boolean;
}

const CanisterSelect: React.FC<CanisterSelectProps> = ({
  canisters,
  selectedCanister,
  onChange,
  label = 'Canister',
  loading,
  hasError = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const canisterId = event.target.value;
    // eslint-disable-next-line no-console
    console.log('Selected Canister ID:', canisterId);
    onChange(canisterId);
  };

  const { t: tCulture } = useTranslation('culture_config');


  return (
    <FormControl fullWidth className="tank-select-container"  error={hasError} >
      <InputLabel shrink={selectedCanister !== null}>{label}</InputLabel>
      <Select
        value={selectedCanister !== null ? String(selectedCanister) : ''}
        onChange={handleChange}
        label={RequiredLabel(label, true)}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200, // Restricts the height of the dropdown
              overflowY: 'auto', // Enables vertical scrolling
            },
          },
        }}
        sx={{
          height: '52px',
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} />   &nbsp; {tCulture('loading', { defaultValue: 'Loading...' })}
          </MenuItem>
        ) : canisters.length ? (
          canisters.map((canister) => (
            <MenuItem key={canister.id} value={canister.id} disabled={Number(canister.occupancy) === 100}>
              <Box className="tank-item">
                <Typography className="tank-item-header" sx={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 700,
                  fontSize: '12px',
                }}>
                  { capitalizeTitle(canister.name || '')}
                  <span className="tank-progress-text">{canister.occupancy?.toFixed(2) ?? '0.00'}%</span>
                </Typography>
                <Box className="progress-bar-container">
                  <LinearProgress
                    variant="determinate"
                    value={canister.occupancy ?? 0}
                    className="progress-bar"
                    sx={{
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: Number(canister.occupancy) === 100 ? '#FF0000' : '#68B62B'

                      },
                    }}
                  />
                </Box>
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>{tCulture('pleaseSelectTank', { defaultValue: 'Please select a tank.' })}</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default CanisterSelect;
